export const selectRsvp = ({rsvp}) => rsvp;
export const selectUserId = ({rsvp}) => rsvp?.userId ?? '';
export const selectEmailMd5 = ({rsvp}) => rsvp?.emailMd5 ?? '';
export const selectEmailSha256 = ({rsvp}) => rsvp?.emailSha256 ?? '';
export const selectHasRsvpd = ({rsvp}) => rsvp?.hasRsvpd ?? false;
export const selectIsFirstRsvpRender = ({rsvp}) => rsvp?.isFirstRsvpRender;
